import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import Exitoso from "../Exitoso";
import Error from "../Error";

import { BASE_URL } from "../../../utils/index";
import { postJson } from "../../../utils/postJson";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > * + *": {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function LoadingServicio(props) {
  useEffect(() => {
    const requestHandle = async () => {
      //   //   //Data
      const {
        tipo,
        direccionHospital,
        fechaCompletaEnviar,
        idPrimerPaciente,
        primerPaciente,
        puebloPrimerPaciente,
        direccionPrimerPaciente,
        telfPrimerPaciente,
        telfPrimerPaciente2,
        NASS1,
        idSegundoPaciente,
        segundoPaciente,
        puebloSegundoPaciente,
        direccionSegundoPaciente,
        telfSegundoPaciente,
        telfSegundoPaciente2,
        NASS2,
        destino,
        sesiones,
        email,
        idCliente,
        idClienteSol,
        perfilLog,
        idPaciente,
        idPaciente2,
        urgente,
        alta,
        ingres,
        fechaCompletaEnviarTarde,
        mananaTarde,
      } = props.values;
      const response2 = await postJson(
        `${BASE_URL}/pedirViajeRadioterapia`,
        {
          email: email,
          fecha: fechaCompletaEnviar,
          fechaTarde: fechaCompletaEnviarTarde,
          tipo: tipo,
          idPrimerPaciente: idPrimerPaciente,
          idDireccionPaciente1: props.values.idDireccionPaciente1,
          primerPaciente: primerPaciente,
          puebloPrimerPaciente: puebloPrimerPaciente.title,
          telfPrimerPaciente: telfPrimerPaciente,
          telfPrimerPaciente2:
            telfPrimerPaciente2 != "" ? telfPrimerPaciente2 : "NO",
          direccionPrimerPaciente: direccionPrimerPaciente,
          NASS1: NASS1,
          idSegundoPaciente: idSegundoPaciente,
          idDireccionPaciente2: props.values.idDireccionPaciente2,
          segundoPaciente: segundoPaciente,
          puebloSegundoPaciente: puebloSegundoPaciente.title,
          telfSegundoPaciente: telfSegundoPaciente,
          telfSegundoPaciente2:
            telfSegundoPaciente2 !== "" ? telfSegundoPaciente2 : "NO",
          direccionSegundoPaciente: direccionSegundoPaciente,
          NASS2: NASS2,
          direccionHospital: direccionHospital.title,
          idCliente: perfilLog == 5 ? idClienteSol.id : idCliente,
          destino: destino.title,
          sesiones: sesiones,
          idPaciente: idPaciente,
          idPaciente2: idPaciente2,
          urgente: urgente,
          alta: alta,
          ingres: ingres,
          mananaTarde: mananaTarde,
        }
      );
      if (typeof response2.message !== "string") {
        throw new Error("El servidor no confirmó la solicitud.");
      }
      setStateComponent({
        isLoading: false,
        isSuccess: true,
        isError: false,
        message: response2.message,
      });
    };
    requestHandle().catch((error) => {
      setStateComponent({
        isLoading: false,
        isSuccess: false,
        isError: true,
        message: error.message,
      });
    });
  }, []);

  const classes = useStyles();

  const [stateComponent, setStateComponent] = useState({
    isLoading: true,
    isSuccess: false,
    isError: false,
    message: "",
  });

  if (stateComponent.isLoading)
    return (
      <div className={classes.root}>
        <LinearProgress />
      </div>
    );

  if (stateComponent.isSuccess) {
    return <Exitoso message={stateComponent.message} />;
  }

  if (stateComponent.isError) {
    return <Error message={stateComponent.message} />;
  }
}
